import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { faArrowUp } from '@fortawesome/free-solid-svg-icons';
import { Chart } from 'node_modules/chart.js';
import { BeneficiaryType } from 'src/app/shared/enum/beneficiary-type';
import { ContributionFilter } from 'src/app/shared/models/previdencia/contribution-filter';
import { TokenService } from 'src/app/shared/services/token.service';
import { SocialSecurityService } from '../../../services/previdencia/social-security.service';
@Component({
  selector: 'app-dashboard-previdencia',
  templateUrl: './dashboard-previdencia.component.html',
  styleUrls: ['./dashboard-previdencia.component.css']
})
export class DashboardPrevidenciaComponent {
  get beneficiaryType() { return BeneficiaryType; }
  faArrowUp = faArrowUp;
  loading: boolean = false;
  loadingPlanData: boolean = true;
  personData: any = null;
  contribuicaoSelecionada: any;
  contribuicaoReserva: any;
  planoSelecionado: any;
  planoVelhoSelecionado: any;
  usuarioAtual: any;
  benefitGranted: any;
  costsTotalChosen: number = 0;
  selectedPlan: any = null;
  valorSelecionado: number = 2023;
  dataSelecionada: any;
  listDesignacaoPoupanca: any;
  listDependentePrevidenciario: any;
  //Variaveis Auxiliares
  listaLabelChart: string[] = [];
  listaValueChart: string[] = [];
  formGroup: FormGroup = new FormGroup({
    anoSelecionado: new FormControl(2023, [Validators.required]),
  });
  private contributionFilter: ContributionFilter = new ContributionFilter(0, 5, null, null);
  myRequests: any = [];
  constructor(private socialSecurityService: SocialSecurityService, private tokenService: TokenService) {
    this.inicializarDashboard();
  }
  changeYear() {
    this.contribuicaoReserva.year.map((value: any) => {
      if (value.year == this.formGroup.get('anoSelecionado')?.value) {
        this.dataSelecionada = value;
      }
    });
  }
  inicializarDashboard() {
    this.loading = true;
    //MÉTODO
    this.usuarioAtual = this.tokenService.getActiveUser();
    //MÉTODO
    this.socialSecurityService.getReserve().subscribe((reserveContribution: any) => {
      this.contribuicaoReserva = reserveContribution;
      this.costsTotalChosen = this.contribuicaoReserva.year.length - 1;
      this.changeYear();
    });
    //MÉTODO
    this.socialSecurityService.getDesignated().subscribe({
      next: (res: any) => {
        this.listDesignacaoPoupanca = res;
      }
    });
    //MÉTODO
    this.socialSecurityService.getDependentes().subscribe({
      next: (res: any) => {
        this.listDependentePrevidenciario = res;
      }
    });
    //MÉTODO
    this.socialSecurityService.getPersonData().subscribe({
      next: (personData: any) => {
        if (personData) {
          this.personData = personData;
          this.planoSelecionado = personData.adesoes[0];
          this.planoVelhoSelecionado = personData.adesoes[1]
          this.contribuicaoSelecionada = personData.contribution[0];
        }
        this.loadingPlanData = false;
      }
    });
    this.socialSecurityService.getBenefitGranted().subscribe({
      next: (benefitsGranted: any) => {
        this.benefitGranted = benefitsGranted.find((b: any) => b.planId == this.planoSelecionado.planId);
        this.loading = !this.loading;
      },
      error: (err: any) => {
        this.loading = !this.loading;
      }
    });
  }
  createLineChart(label: string[], data: string[]) {
    const currencyFormatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD' // Código da moeda (por exemplo, USD, EUR)
    });
    const chart = new Chart('lineChart', {
      type: 'bar',
      data: {
        labels: ['Participante', 'Patrocinadora', 'Rentabilidade'],
        datasets: [
          {
            label: 'R$',
            data: [this.contribuicaoReserva?.sponsor, this.contribuicaoReserva?.person, this.contribuicaoReserva?.profit],
            borderWidth: 1
          },
          {
            label: 'R$',
            data: [this.dataSelecionada?.sponsor, this.dataSelecionada?.person, this.dataSelecionada?.profit],
            borderWidth: 1
          },
        ]
      },
      options: {
        plugins: {
          legend: {
            display: false,
            labels: {
              // This more specific font property overrides the global property
              font: {
                size: 12
              }
            }
          },
          datalabels: {
            align: 'top',
          }
        },
        responsive: true,
        scales: {
          y: { display: false },
        },
      }
    });
  }
}